import React, { useEffect, useState } from 'react';
import { readMasqueradeSession, stopMasquerade } from '../lib/masquerade';

/**
 * Fixed bar shown while a staff member is viewing the app as another user.
 * Shifts the fixed header and page padding down so it does not cover them.
 */
const MasqueradeBanner = () => {
  const [session, setSession] = useState(() => readMasqueradeSession());
  const [exiting, setExiting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const root = document.documentElement;
    if (session) {
      root.classList.add('masquerade-active');
    } else {
      root.classList.remove('masquerade-active');
    }
    return () => root.classList.remove('masquerade-active');
  }, [session]);

  if (!session) return null;

  const handleExit = async () => {
    setExiting(true);
    setError('');
    try {
      await stopMasquerade();
    } catch (err) {
      setError(err?.message || 'Could not exit masquerade');
      setExiting(false);
    }
  };

  const label = session.targetName || 'another user';
  const email = session.targetEmail ? ` (${session.targetEmail})` : '';

  return (
    <>
      <style>{`
        html.masquerade-active header.fixed.top-0 { top: 2.5rem; }
        html.masquerade-active main.pt-16,
        html.masquerade-active div.pt-16 { padding-top: 6.5rem; }
      `}</style>
      <div className="fixed top-0 left-0 right-0 z-[60] h-10 bg-amber-500 text-amber-950 flex items-center justify-center gap-3 px-4 text-sm font-medium">
        <span className="truncate">
          Viewing as {label}{email}
        </span>
        <button
          type="button"
          onClick={handleExit}
          disabled={exiting}
          className="shrink-0 rounded-md bg-amber-950 px-2.5 py-1 text-xs font-semibold text-amber-50 hover:bg-amber-900 disabled:opacity-60"
        >
          {exiting ? 'Exiting…' : 'Exit'}
        </button>
        {error && <span className="truncate text-xs font-normal">{error}</span>}
      </div>
    </>
  );
};

export default MasqueradeBanner;
